module.exports = __webpack_public_path__ + "static/media/blog3.abada5fc.jpg";